<template>
  <div
    v-if="vehicleOrganizationId != null"
    style="margin-top: 30px; margin-bottom: 30px"
  >
    <div class="loader d-flex justify-content-center" v-if="this.loading">
      <b-spinner :label="$t('common_phrases.loading')"></b-spinner>
    </div>
    <div v-if="this.vehicleParams != null" class="vehicleDetails">
      <b-row v-if="this.organizationName && $UiConfig('/data/vehicle/showOrganizationName', false)">
        <b-col>{{ $t('vehicles.feature.organization_name') }}</b-col>
        <b-col>{{ this.organizationName }}</b-col>
      </b-row>
      <b-row v-for="param in this.vehicleParams" :key="param.id">
        <b-col>{{ $t(param.descriptionId) }}</b-col>
        <b-col>{{ attribValue(param.name) }}</b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
//import moment from 'moment';
import realtime from '@/store/realtime/realtime'

export default {
  name: 'VehicleOrganizationFeatures',
  props: ['vehicle'],
  data: function () {
    return {
      loading: true,
      vehicleParams: null,
      vehicleOrganizationId: null,
      organizationName: null
    }
  },
  computed: {},
  mounted: function () {
    this.vehicleOrganizationId = this.$props.vehicle.organization
    if (this.$store.state.realtime) {
      if (this.vehicleOrganizationId == null) {
        this.vehicleParams = {}
        this.loading = false
        return
      }
      this.$store
        .dispatch(
          'realtime/getOrganizationVehicleFeatures',
          this.vehicleOrganizationId
        )
        .then((data) => {
          this.vehicleParams = data.data || []
          if (this.vehicleParams && this.vehicleParams.length > 0) {
            this.vehicleParams = this.vehicleParams.filter((param) => param.descriptionId != 'vehicles.feature.can_data')
          }
          this.loading = false
        })
        .catch(() => {
          this.vehicleParams = []
          this.loading = false
        })
      this.$store
        .dispatch(
          'realtime/getOrganizationName',
          this.vehicleOrganizationId
        )
        .then((data) => {
          this.organizationName = data.data
        })
    }
  },
  beforeCreate: function () {
    if (!this.$store.state.realtime) {
      this.$store.registerModule('realtime', realtime)
    }
  },
  methods: {
    attribValue: function (paramName) {
      const item = this.$props.vehicle.features[paramName]
      if (item != undefined) {
        return item
      }
    },
  },
}
</script>

<style scoped lang="scss">
.row {
  font-size: 0.75rem;
  white-space: pre-wrap;
  margin-bottom: 5px;
}

.col:first-child {
  font-weight: normal;
}
</style>
